<template>
    <div class="slider"
         v-touch:swipe.right="setPrevSlide"
         v-touch:swipe.left="setNextSlide"
         v-if="slides.length > 0">
        <div class="slides">
            <transition-group tag="div" :name="options.transitionType" mode="in-out">
                <div :key="slide.id" class="slide" v-for="(slide,index) in visibleSlides"
                     :class="getSlideClass()" @click="modalToggle">
                    <!--                    :img-normal="mobile ? slide.mobi : slide.origin"-->
                    <product-slider-zoom :img-normal="slide.origin"

                                         :scale="2.0"></product-slider-zoom>
                </div>
            </transition-group>
        </div>
        <div v-if="options.arrows"
             class="arrow prev-arrow"
             @click="setPrevSlide">
            <i class="fa fa-2x fa-chevron-left"></i>
        </div>
        <div v-if="!mobile"
             class="thumb-dots">
            <div class="thumb-dots-block" v-for="(thumbDot,index) in visibleThumbDots"
                 :class="visibleSlides[0].id === thumbDot.id ? 'active' : ''">
                <img
                        @click="changeImageByDot(thumbDot.id)"
                        :src="thumbDot.thumb"
                        :alt="thumbDot.alt"
                >
            </div>
        </div>
        <div v-if="mobile"
             class="dots">
            <div class="dot" v-for="(thumbDot,index) in visibleThumbDots"
                 :class="visibleSlides[0].id === thumbDot.id ? 'active' : ''" @click="changeImageByDot(thumbDot.id)">
            </div>
        </div>
        <div v-if="options.arrows"
             class="arrow next-arrow"
             @click="setNextSlide">
            <i class="fa fa-2x fa-chevron-right"></i>
        </div>

        <div v-if="showModal" class="product-page-modal">
            <div class="modal-background" @click="modalToggle"></div>
            <div class="slider-modal-content">
                <div class="modal-header">
                    <p class="h1">{{modalData.name}}</p>

                    <div class="block-buttons">
                        <div class="modal-price"
                        <button class="modal-close" @click="modalToggle"></button>
                    </div>
                </div>
                <div class="content-body">
                    <div class="row">
                        <div v-if="slides.length > 1" class="col-auto pr-0">
                            <div v-if="visibleThumbDots.length > 1 && !mobile"
                                 class="modal-thumb-dots">
                                <img v-for="(thumbDot,index) in visibleThumbDots"
                                     @click="changeImageByDot(thumbDot.id)"
                                     :src="thumbDot.thumb"
                                     :alt="thumbDot.alt"
                                     :class="visibleSlides[0].id === thumbDot.id ? 'active' : ''">
                            </div>
                        </div>
                        <div class="modal-slides col"
                             v-touch:swipe.right="setPrevSlide"
                             v-touch:swipe.left="setNextSlide">
                            <div class="row align-items-center h-100">
                                <div class="arrow prev-arrow col-auto pr-0"
                                     @click="setPrevSlide">
                                    <i class="fa fa-2x fa-chevron-left"></i>
                                </div>
                                <div class="col">
                                    <transition-group tag="div" :name="options.transitionType" mode="in-out">
                                        <div :key="slide.id" class="slide" v-for="(slide,index) in visibleSlides"
                                             :class="getSlideClass()">
                                            <img :src="slide.origin" :alt="slide.alt">
                                        </div>
                                    </transition-group>
                                </div>
                                <div class="arrow next-arrow col-auto pl-0"
                                     @click="setNextSlide">
                                    <i class="fa fa-2x fa-chevron-right"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue2TouchEvents from 'vue2-touch-events';
    import ProductSliderZoom from './ProductSliderZoom';


    Vue.use(Vue2TouchEvents);

    export default {
        name: 'ProductSlider',
        components: {
            ProductSliderZoom,
        },
        data() {
            return {
                servicePageData: window.servicePageData,
                maxScrollSteps: 0,
                currentSlidesIndex: 0,
                mobile: false,
                scrollTo: 'left-scroll',
                loading: true,
                showModal: false,
                options: {
                    arrows: false,
                    modal: true,
                    transitionType: 'fade',
                    slidesToScroll: 1
                },
                Lang,
            }
        },
        computed: {
            slides() {
                let slides = this.servicePageData.services['0'].slides;
                console.log(this.servicePageData);
                if (slides) {
                    return slides
                } else {
                    return [];
                }
            },


            modalData() {
                let modalData = this.servicePageData;
                if (modalData) {
                    return modalData
                } else {
                    return {
                        'name': '',
                    };
                }
            },
            visibleSlides() {
                return [this.slides[this.skipSlides]];
            },

            visibleThumbDots() {
                let visible = [];

                if (!this.loading) {
                    if (this.slides.length > 1) {
                        let prev = this.getPrevSlide();
                        let next = this.getNextSlide();

                        visible = visible.concat(this.slides);
                    } else {
                        visible = visible.concat(this.visibleSlides);
                    }

                }

                return visible;
            },
            skipSlides() {
                let skip = this.currentSlidesIndex;
                if (this.options.slidesToScroll !== 1) {
                    skip = this.currentSlidesIndex * this.options.slidesToScroll;
                }
                return skip;
            }

        },
        watch: {
            currentSlidesIndex: function (newVal, oldVal) {
                if (newVal > oldVal) {
                    this.scrollTo = 'left-scroll';
                } else {
                    this.scrollTo = 'right-scroll';
                }
            },
            slides: function (newVal, oldVal) {
                this.currentSlidesIndex = 0;
            },
        },
        methods: {
            setPrevSlide() {
                this.currentSlidesIndex = this.getPrevSlide();
            },
            setNextSlide() {
                this.currentSlidesIndex = this.getNextSlide();
            },
            getPrevSlide() {
                return helpers.getPreviousElement(this.maxScrollSteps, this.currentSlidesIndex);
            },
            getNextSlide() {
                return helpers.getNextElement(this.maxScrollSteps, this.currentSlidesIndex);
            },
            changeImage(key) {
                this.currentSlidesIndex = key;
            },
            changeImageByDot(id) {
                let imgIndex = this.slides.findIndex((element, index, array) => {
                    if (element.id === id) {
                        return element;
                    }
                });

                this.currentSlidesIndex = imgIndex;
            },
            getSlideClass() {
                let slideClass = this.scrollTo;

                if (this.visibleSlides.length > 1) {
                    slideClass += ' inline-slides';
                }

                return slideClass;
            },
            modalToggle() {
                this.showModal = !this.showModal;
            }
        },
        mounted() {
            if (document.documentElement.clientWidth <= 768) {
                this.mobile = true;
            }

            this.maxScrollSteps = Math.ceil(this.slides.length / this.options.slidesToScroll);

            this.loading = false;
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/product/ProductSlider.vue